import { useTranslation } from 'react-i18next';
import useFormsIntegrationHelpers from '../../../hooks/useFormsIntegrationHelpers';
import { useParams } from 'react-router-dom';
import TableSkeleton from '../../../components/loaders/TableSkeleton';
import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import SingleFinancingDetails from '../../../modules/financingApplications/components/SingleFinancingDetails';

const SingleFinancingApplication = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { apiData, getDataLoading } = useFormsIntegrationHelpers({
    queryKey: ['financing-applications', id],
    id,
    singleGetApi: `/admin/finance-applications/${id}`
  });

  const dispatch = useDispatch();
  dispatch(
    setBreadCrumbsData({
      page_title: t('application_details')
    })
  );

  if (getDataLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="single-order-container">
      <SingleFinancingDetails data={apiData} />
    </div>
  );
};

export default SingleFinancingApplication;
